import { render } from "./mvt-toggle-switch.vue?vue&type=template&id=47457ac6&scoped=true"
import script from "./mvt-toggle-switch.vue?vue&type=script&lang=js"
export * from "./mvt-toggle-switch.vue?vue&type=script&lang=js"

import "./mvt-toggle-switch.vue?vue&type=style&index=0&id=47457ac6&lang=scss&scoped=true"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47457ac6"]])

export default __exports__